import { Component, OnInit, Input, OnDestroy, ElementRef } from '@angular/core';
import { _MSGTYPES } from '../../../constant/msgType';
import echarts from 'echarts';
import { formatNumber } from '../../../utils/common';

@Component({
  selector: 'icc-radio-msg-send',
  templateUrl: './icc-radio-msg-send.component.html',
  styleUrls: ['./icc-radio-msg-send.component.less'],
})
export class IccRadioMsgSendComponent implements OnInit, OnDestroy {
  constructor(private el: ElementRef) {}
  // 图谱实例
  chartIns: any;
  colorList = ['#58d3ff', '#34a2ff', '#23d3a0', '#91ef7a', '#fbbb15', '#fb7649', '#e9ef00', '#7e85e6'];
  pieData: Array<{
    name: string; // 消息类型名称
    value: number; // 发送量
    valueStr: string; // 千分符格式化发送量
    radio: number; // 发送占比
    ranking: number; // 排名浮动：0为不变 1为上升 2为下降
  }>;
  // 数据源
  @Input() reportType: number;
  @Input() data: Array<{
    msgType: number; // 消息类型
    count: number; // 发送量
    radio: number; // 发送占比
    ranking: number; // 排名浮动：0为不变 1为上升 2为下降
  }>;
  maxRatioName: string;
  noData: any = true;
  // 自适应函数
  resizeCharts = () => {
    if (this.chartIns) {
      this.chartIns.resize();
    }
  };
  ngOnInit() {
    if (this.data instanceof Array && this.data.length) {
      this.pieData = this.formatPieData();
      setTimeout(() => {
        this.createLineChart('chart-el');
      }, 0);
      window.addEventListener('resize', this.resizeCharts);
      this.noData = false;
    }
  }
  ngOnDestroy() {
    if (this.chartIns) {
      this.chartIns.dispose();
      this.chartIns = null;
    }
    window.removeEventListener('resize', this.resizeCharts);
  }
  formatPieData() {
    const result = [];
    let maxRatio = 0;
    let names = [];
    this.data.forEach((item: any) => {
      const temp: any = {};
      const msgItem = _MSGTYPES.getMsgByType(false, item.msgType);
      temp.name = msgItem.name || '其他';
      temp.value = item.count;
      temp.valueStr = formatNumber(item.count);
      temp.radio = item.ratio;
      temp.ranking = item.ranking;
      result.push(temp);
      if (maxRatio < item.ratio) {
        names = [temp.name];
        maxRatio = item.ratio;
      } else if (maxRatio == item.ratio) {
        names.push(temp.name);
      }
    });
    if (maxRatio) {
      this.maxRatioName = names.join(',');
    }
    return result;
  }
  /* 生成图谱 */
  createLineChart(chartCls) {
    const elCollection = this.el.nativeElement.getElementsByClassName(chartCls);
    if (!this.chartIns && elCollection.length) {
      this.chartIns = echarts.init(elCollection[0]);
    }
    this.chartIns.setOption({
      tooltip: {
        trigger: 'item',
        formatter: '{b} : {c}',
      },
      legend: {
        show: false,
      },
      series: [
        {
          type: 'pie',
          color: this.colorList,
          radius: '42%',
          center: '50%',
          roseType: false,
          label: {
            normal: {
              formatter: params => {
                return '{b| ' + params.name + '}  ' + '{c|' + params.percent + '%}';
              },
              borderWidth: 0,
              borderRadius: 4,
              padding: [0, -80, 0, -80],
              height: 30,
              fontSize: 12,
              align: 'center',
              color: '#9ea8c8',
              rich: {},
            },
          },
          labelLine: {
            length1: 20,
            length2: 80,
            lineStyle: {
              color: '#eaecf0',
            },
          },
          data: this.pieData,
        },
      ],
    });
  }
}
